import { render, staticRenderFns } from "./WebBottom.vue?vue&type=template&id=b867bc02&"
import script from "./WebBottom.vue?vue&type=script&lang=js&"
export * from "./WebBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports